'use es6';

import I18n from 'I18n';
const VerificationEmailResentMessage = () => `
  <p class="display-inline">
    <strong>${I18n.text('emailConfirmBar.resentText')}</strong>
  </p>
`;
export default VerificationEmailResentMessage;